import { Directive } from '@angular/core';

/**
 * The one text control in this UI — a box, a number, a date, a note, a closed list, or the button
 * that unfolds one. Applied to the element rather than wrapping it, so a control keeps its own
 * width, alignment and figure style while every form reads at the same height and says the same
 * thing when it is disabled.
 *
 * Width is deliberately not set here: how wide a field runs is what the form around it decides.
 */
@Directive({
  selector: 'input[guaranteesControl], textarea[guaranteesControl], select[guaranteesControl], button[guaranteesControl]',
  standalone: true,
  host: {
    class:
      'rounded-md border border-neutral-200 bg-neutral-0 px-2 py-1.5 text-sm text-neutral-800 placeholder:text-neutral-400 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none disabled:bg-neutral-50 disabled:text-neutral-400',
  },
})
export class ControlDirective {}
